<template>
  <section>
    <div class="contact-container container mt-30">
      <Loader :visible="loading"></Loader>
      <div class="row">
        <div class="col-md-2 col-1"></div>
        <div class="col-md-8 col-10">
          <div align="center">
            <div class="message_circle">
              <i class="far fa-envelope icon_message"></i>
            </div>
            <h2 class="page-title">{{$t("contact.title")}}</h2>
          </div>
          <div class="row mt-5">
            <div class="col-md-6">
              <form @submit.prevent="send" method="post">
                <div class="form-group">
                  <input type="text" v-model="contact.name" required class="form-control input-form" :placeholder="$t('contact.name')" />
                </div>
                <div class="form-group">
                  <input type="email" v-model="contact.email" required class="form-control input-form" :placeholder="$t('contact.email')" />
                </div>
                <div class="form-group">
                  <input type="text" v-model="contact.subject" required class="form-control input-form" :placeholder="$t('contact.subject')" />
                </div>
                <div class="form-group">
                  <textarea class="form-control textarea-form"
                    required
                    :placeholder="$t('contact.message')"
                    rows="4"
                    v-model="contact.message">
                   </textarea>
                </div>
                <div class="row" style="margin-top: 30px">
                  <div class="col-md-6">
                    <button type="submit" class="primary-btn-light">
                      {{$t("contact.send")}}
                    </button>
                  </div>
                </div>
              </form>

            </div>
            <div class="col-md-6" style="margin-top: 20px">
              <p v-if="partner.hasPhone()">
                <i class="fas fa-phone-alt right_icon"></i>
                {{partner.contact_phone}}
              </p>
              <p >
                <i class="fas fa-envelope right_icon"></i>
                {{partner.contact_email}}
              </p>
              <!--p>
                <i class="fas fa-map-marker-alt right_icon"></i>
                Hidamdo #2011, Gudalajara
              </p-->
            </div>
          </div>
        </div>
        <div class="col-md-2 col-1">
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Loader from "../components/Loader"
import Partner from "../models/Partner"
import Contact from "../models/Contact"

export default {
  name: "Contact",
  components:{
    Loader
  },
  data() {
    return{
      loading: false,
      partner: new Partner(),
      contact: new Contact()
    }
  },
  created() {
    this.$root.$on('setPartner', this.setPartner)
  },
  methods:{
    async send() {
      this.loading = true
      const response = await this.contact.sendEmail()

      if(response) {
        this.$alertify.success(this.$t("contact.success"))
        this.contact = new Contact()
      } else {
        this.$alertify.error(this.$t("contact.error"))
      }
      this.loading = false
    },
    setPartner(partner) {
      this.partner = partner
    }
  }
}
</script>

<style lang="scss">
  .contact-container {
    margin-bottom: 80px;
  }
</style>
